module.exports = __webpack_public_path__ + "static/you-travel-0a96eac84b5c819cc3efce4804644db6.png";